export default __webpack_public_path__ + "static/media/colt-express.6b67a314.jpg";